import { useHistory, useParams } from "react-router-dom";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ReactMultiSelect } from "../../components/utilityComponent/form-fields";
import { fetchProduct, setCatData } from "../../redux/actions";




const FormSchema = Yup.object({
  categoryId: Yup.string()
    .trim()
    .required("Category Id is required"),
  subCategoryId: Yup.string()
    .trim()
    .required("Sub category Id is required"),
});

const PostNewListing = () => {
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { productId } = useParams();
  // const id = query['id'];
  const dispatch = useDispatch();

  let product = useSelector((state) => { return state.productDetails.listing; })
  const user = useSelector((state) => { return state.userDetails.user });

  if (productId) {
    product = product.find((p => p._id === productId))
  }
  else {
    product = null;
  }

  const categories = useSelector((state) => state.categoryDetail.categories);
  const subCategories = useSelector((state) => state.subCategoryDetail.subCategories);

  const categoryOptions = categories.map((category) => {
    return {
      key: category._id,
      label: category.name,
      value: category._id,
    };
  });

  const subCategoryOptions = subCategories.map((category) => {

    return {
      key: category._id,
      label: category.name,
      value: category._id,
      parentCategoryId: category.categoryId
    };
  });

  const [initialValues, setInitialValues] = useState({ categoryId: product ? product.categoryId : "", subCategoryId: product ? product.subCategoryId : "", });
  const [subcategory, setSubCategory] = useState(product ? subCategoryOptions.find(option => option.value === product.subCategoryId) : "");

  const onCategoryChange = (e) => {
    setInitialValues({ ...initialValues, categoryId: e.value, subCategoryId: "" });
    setSubCategory(null);
  };


  const onSubCategoryChange = (e) => {
    setInitialValues({ ...initialValues, subCategoryId: e.value });
    setSubCategory(subCategoryOptions.find((option) => {
      return option.value === e.value;
    }));
  };

  const onSubmit = (values) => {
    // console.log("Values", values);
    let subCategory = subCategories.filter((cat) => {
      return cat._id === values.subCategoryId;
    });
    let category = categories.filter((cat) => {
      return cat._id === values.categoryId;
    });
    // if(id){
    //   dispatch(setCatData({
    //     values: {
    //       ...values,
    //       categoryName: category[0].title,
    //       subCategoryName: subCategory[0].title
    //     },
    //   }))
    //   history.push(`/add-new-product/${id}`
    //   );
    // }else{
    dispatch(setCatData({
      values: { ...values, categoryName: category[0].title, subCategoryName: subCategory[0].title },
    }))
    // alert("alert")
    if (productId)
      history.push(`/new-product-form/${productId}`);
    else
      history.push(`/new-product-form`);
    // }





  };

  // useEffect(() => {
  //     let id = query['id'];
  //   if(query['id']){
  //     dispatch(
  //       fetchProduct({
  //           id,
  //         callback: (data) => {
  //           setInitialValues({
  //             categoryId: data.categoryId,
  //             subCategoryId: data.subCategoryId,
  //           });
  //           setSubCategory(subCategoryOptions.find((option) => {
  //             return option.value === data.subCategoryId;
  //           }));
  //         },
  //       })
  //     );
  //   }
  // }, [dispatch, query['id']]);


  return (
    <>
      <div className="dashContentHeader px-5 mb-0 row">
        <h5 className="col-12 p-0 dashHeading mb-0">Post New Listing</h5>
        <p className="col-12 p-0  text-lt mt-3 font-16">
          {" "}
        </p>
      </div>
      <div className="row dashboardCardRow px-5">
        <div className="col-lg-6 bg-white mt-5 shadow">
          <Formik
            initialValues={initialValues}
            validationSchema={FormSchema}
            onSubmit={onSubmit}
            enableReinitialize
          >
            {({ errors, values }) => (
              <Form className="mg-login new-product mt-4 px-3">
                <div className="row mb-0">
                  <div className="col-md-12 mb-4 ">
                    <ReactMultiSelect
                      label="CHOOSE A CATEGORY"
                      options={categoryOptions}
                      handleChange={onCategoryChange}
                      name="categoryId"
                      id="categoryId"
                      value={categoryOptions.find((option) => {
                        return option.value === values.categoryId;
                      })}
                      placeholder="CATEGORY"
                      className="form-control form-select"
                      errors={errors}
                      isRequired
                    />
                  </div>
                  <div className="col-md-12 mb-4">
                    <ReactMultiSelect
                      label="CHOOSE A SUB CATEGORY"
                      options={subCategoryOptions.filter((data) => {
                        return data.parentCategoryId === initialValues.categoryId
                      })}
                      handleChange={onSubCategoryChange}
                      name="subCategoryId"
                      id="subCategoryId"
                      value={subcategory}
                      placeholder="SUB CATEGORY"
                      className="form-control form-select"
                      errors={errors}
                      isRequired
                    />
                  </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between mb-5">
                  {/* <Link
                href={{
                  pathname: "/newproduct",
                  query: { category: category },
                }}
                as="/newproduct"
              > */}
                  <button className="mb-5 sub-button mt-4 px-4" onClick={() => {
                    if (user.role[0] === "admin")
                      history.push("/admin-listing")
                    else
                      history.push("/user-listing")
                  }}>Back</button>
                  <button type="submit" className="mb-5 sub-button mt-4 px-4">
                    Next Step
                  </button>
                  {/* </Link> */}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default PostNewListing;